//node_modules
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

//components
import SidebarMenu from "../../components/SidebarMenu";
import { useMobile } from "../../hooks/useMobile";
import ChefManagement from "./components/ChefManagement";
import ChefCreatePage from "./components/ChefManagement/ChefCreatePage";
import ChefEditPage from "./components/ChefManagement/ChefEditPage";
import ChefPasswordPage from "./components/ChefManagement/ChefPasswordPage";
import MenuItems from "./components/MenuItems";
import OptionGroupCreatePage from "./components/MenuItems/OptionGroupCreatePage";
import OptionGroupEditPage from "./components/MenuItems/OptionGroupEditPage";
import OptionItemCreatePage from "./components/MenuItems/OptionItemCreatePage";
import OptionItemEditPage from "./components/MenuItems/OptionItemEditPage";
import Scheduling from "./components/Scheduling";
import Stations from "./components/Stations";
import StationCreatePage from "./components/Stations/StationCreatePage";
import StationEditPage from "./components/Stations/StationEditPage";
import DiningOptions from "./components/DiningOptions";
import DiningOptionCreatePage from "./components/DiningOptions/DiningOptionCreatePage";
import DiningOptionEditPage from "./components/DiningOptions/DiningOptionEditPage";
import StationOptions from "./components/StationItems";
import StationMenuItem from "./components/StationMenuItem";
import Statistics from "./components/Statistics";

//styles
import * as styles from "./ManagerPortal.module.css";

function ManagerPortal() {
  useMobile();
  return (
    <div className={styles.managerPortal}>
      <SidebarMenu
        menuItems={[
          {
            link: "/app/manager/stations",
            id: "stations",
            title: "Stations",
            icon: "pi-list",
          },
          {
            link: "/app/manager/scheduling",
            id: "scheduling",
            title: "Scheduling",
            icon: "pi-calendar-clock",
          },
          {
            link: "/app/manager/dining-options",
            id: "dining-options",
            title: "Dining options",
            icon: "pi-box",
          },
          {
            link: "/app/manager/menu-items",
            id: "menu-items",
            title: "Menu items",
            icon: "pi-cog",
          },
          {
            link: "/app/manager/chefs",
            id: "chefs",
            title: "Chefs",
            icon: "pi-user",
          },
          {
            link: "/app/manager/station-stat",
            id: "station-stat",
            title: "Statistic",
            icon: "pi-chart-line",
          },
        ]}
        title={"Manager Portal"}
      />
      <div className={styles.routeContainer}>
        <Routes>
          <Route path="stations" element={<Stations />} />
          <Route path="stations/create" element={<StationCreatePage />} />
          <Route path="stations/:id/edit" element={<StationEditPage />} />
          <Route path="scheduling" element={<Scheduling />} />
          <Route path="dining-options" element={<DiningOptions />} />
          <Route
            path="dining-options/create"
            element={<DiningOptionCreatePage />}
          />
          <Route
            path="dining-options/:id/edit"
            element={<DiningOptionEditPage />}
          />
          <Route path="menu-items" element={<MenuItems />} />
          <Route
            path="menu-items/groups/create"
            element={<OptionGroupCreatePage />}
          />
          <Route
            path="menu-items/groups/:id/edit"
            element={<OptionGroupEditPage />}
          />
          <Route
            path="menu-items/groups/:groupId/options/create"
            element={<OptionItemCreatePage />}
          />
          <Route
            path="menu-items/options/:id/edit"
            element={<OptionItemEditPage />}
          />
          {/* <Route path="menu-items/:id" element={<StationMenuItem />} /> */}
          <Route path="chefs" element={<ChefManagement />} />
          <Route path="chefs/create" element={<ChefCreatePage />} />
          <Route path="chefs/:id/edit" element={<ChefEditPage />} />
          <Route path="chefs/:id/password" element={<ChefPasswordPage />} />
          <Route path="station-stat" element={<Statistics />} />

          <Route index element={<Navigate to="stations" />} />
          <Route path="*" element={<Navigate to="stations" />} />
        </Routes>
      </div>
    </div>
  );
}

export default ManagerPortal;
